import '../grand_league_leaderboard/index.css';
import { useLink } from 'react-router-stack';
import { useState, SyntheticEvent } from 'react';
import { View, RouteWrapper, ScreenBackground, Header } from '../../../component';
import GrandLeagueWinnings from '../../component/grand_league_winnings';
import WeekendLeaderBoardList from '../../component/weekend_leaderboard_list';
import GrandLeagueLeaderBoardTab from '../../component/grand_league_leaderboard_tab';
import SwipeableViews from 'react-swipeable-views';
import Constants from '../../../constants';

const WeekendLeaderboard = () => {
  const navigate = useLink();
  const [activeTab, setActiveTab] = useState(0);

  const [routes] = useState([
    { key: 'Winnings_Breakup', title: 'Winnings Breakup' },
    { key: 'Leaderboard', title: 'Leaderboard' }
  ]);

  const onChangeIndex = (index = 0) => {
    setActiveTab(index);
  };
  const onChangeTab = (_event: SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };
  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header onClickBack={onPressBack} title="Weekend Leaderboard (23rd to 24th April)" />
        <View className={'grand-league-leaderboard-tab-view-wrapper '}>
          <View
            style={{
              flexGrow: 1,
              height: '100%'
            }}>
            <GrandLeagueLeaderBoardTab
              activeTab={activeTab}
              onChangeTab={onChangeTab}
              routes={routes}
            />
            <div className="flat-list-outer-grow">
              <SwipeableViews
                index={activeTab}
                onChangeIndex={onChangeIndex}
                className={'grand-league-leaderboard-swipeable-view'}>
                <GrandLeagueWinnings list={Constants.WeekendLeaderBoardList} />
                <WeekendLeaderBoardList />
              </SwipeableViews>
            </div>
          </View>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default WeekendLeaderboard;
